// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-placement {
    display: flex;
    justify-content: center;
    padding-bottom: 40px;
    overflow: visible;
}

.slide-content {
    border-radius: 50px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    position: relative;
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    height: calc(75% + 50px);
    width: 350px;

    @media screen and (max-width: 459px){
        width: 95vw;
    }
}

.module-slide{
    width: 350px;

    @media screen and (max-width: 489px){
        width: 95vw;
    }
}

.slide-content img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.slide-white-text {
    position: absolute;
    top: 10px;
    left: 40px;
    z-index: 10;
    font-weight: bold;
    color: white;

    .number-white-bg{
        display: inline-block;
        background-color: white;
        padding: 0 4px;
        border-radius: 4px;
        color: #222D32;

        margin-right: 4px;
    }
}

.slide-black-text {
    position: absolute;
    top: 10px;
    left: 40px;
    z-index: 10;
    font-weight: bold;
    color: #222D32;

    .number-black-bg{
        display: inline-block;
        background-color: #222D32;
        padding: 0 4px;
        border-radius: 4px;
        color: white;

        margin-right: 4px;
    }
}

.slide-content:nth-child(2n) .slide-text {
    color: black;
}

.navigation-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    @media screen and (max-width: 1024px){
        display: none;
    }
}

.nav-button {
    width: 40px; /* Встановлюємо ширину */
    height: 40px; /* Встановлюємо висоту */
    border-radius: 50%; /* Круглі кнопки */
    margin-left: 20px;
    background-color: #d8d8d8;
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center; /* Центруємо іконки */
    transition: background-color 0.3s;
}

.nav-button:hover {
    background-color: gray;
}

.nav-button svg {
    width: 20px; /* Розмір іконки */
    height: 20px;
}

.swiper-button-prev::after, .swiper-rtl, .swiper-button-next::after {
    content: '';
}`, "",{"version":3,"sources":["webpack://./src/styles/slider.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB,mEAAmE;IACnE,wBAAwB;IACxB,YAAY;;IAEZ;QACI,WAAW;IACf;AACJ;;AAEA;IACI,YAAY;;IAEZ;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,YAAY;;IAEZ;QACI,qBAAqB;QACrB,uBAAuB;QACvB,cAAc;QACd,kBAAkB;QAClB,cAAc;;QAEd,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,cAAc;;IAEd;QACI,qBAAqB;QACrB,yBAAyB;QACzB,cAAc;QACd,kBAAkB;QAClB,YAAY;;QAEZ,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;;IAEhB;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW,EAAE,wBAAwB;IACrC,YAAY,EAAE,wBAAwB;IACtC,kBAAkB,EAAE,kBAAkB;IACtC,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAE,qBAAqB;IAC9C,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW,EAAE,kBAAkB;IAC/B,YAAY;AAChB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".slider-placement {\n    display: flex;\n    justify-content: center;\n    padding-bottom: 40px;\n    overflow: visible;\n}\n\n.slide-content {\n    border-radius: 50px;\n    overflow: hidden;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    position: relative;\n    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n    height: calc(75% + 50px);\n    width: 350px;\n\n    @media screen and (max-width: 459px){\n        width: 95vw;\n    }\n}\n\n.module-slide{\n    width: 350px;\n\n    @media screen and (max-width: 489px){\n        width: 95vw;\n    }\n}\n\n.slide-content img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n}\n\n.slide-white-text {\n    position: absolute;\n    top: 10px;\n    left: 40px;\n    z-index: 10;\n    font-weight: bold;\n    color: white;\n\n    .number-white-bg{\n        display: inline-block;\n        background-color: white;\n        padding: 0 4px;\n        border-radius: 4px;\n        color: #222D32;\n\n        margin-right: 4px;\n    }\n}\n\n.slide-black-text {\n    position: absolute;\n    top: 10px;\n    left: 40px;\n    z-index: 10;\n    font-weight: bold;\n    color: #222D32;\n\n    .number-black-bg{\n        display: inline-block;\n        background-color: #222D32;\n        padding: 0 4px;\n        border-radius: 4px;\n        color: white;\n\n        margin-right: 4px;\n    }\n}\n\n.slide-content:nth-child(2n) .slide-text {\n    color: black;\n}\n\n.navigation-buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n\n    @media screen and (max-width: 1024px){\n        display: none;\n    }\n}\n\n.nav-button {\n    width: 40px; /* Встановлюємо ширину */\n    height: 40px; /* Встановлюємо висоту */\n    border-radius: 50%; /* Круглі кнопки */\n    margin-left: 20px;\n    background-color: #d8d8d8;\n    color: white;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center; /* Центруємо іконки */\n    transition: background-color 0.3s;\n}\n\n.nav-button:hover {\n    background-color: gray;\n}\n\n.nav-button svg {\n    width: 20px; /* Розмір іконки */\n    height: 20px;\n}\n\n.swiper-button-prev::after, .swiper-rtl, .swiper-button-next::after {\n    content: '';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
